<template>
  <el-form
    ref="personalForm"
    :model="formData"
    :rules="rules"
    label-width="180px"
    class="resume-form-content"
  >
    <div class="form-section">
      <div class="form-row">
        <el-form-item label="姓名" prop="nickName">
          <el-input
            :disabled="newMode == 'employer'"
            v-model="formData.nickName"
            placeholder="请输入姓名"
            clearable
          />
        </el-form-item>
        <el-form-item label="个人免冠照片" prop="registerInfo.personalPhoto">
          <el-upload
            :action="uploadUrl"
            :on-success="
              (response, file, fileList) =>
                handleUploadSuccess('personalPhoto', response, file, fileList)
            "
            :on-error="handleUploadError"
            :before-upload="(file) => beforeUpload('image', file)"
            :limit="1"
            :file-list="personalPhotoList"
            :on-exceed="handleExceed"
            :on-remove="
              (file, fileList) => handleRemove('personalPhoto', file, fileList)
            "
            accept="image/*"
          >
            <el-button
              :disabled="newMode == 'employer'"
              type="success"
              size="small"
              @click="submitUpload('image')"
              >上传图片</el-button
            >
          </el-upload>
          <div v-if="formData.registerInfo.personalPhoto" class="image-preview">
            <img
              :src="formData.registerInfo.personalPhoto"
              alt="个人免冠照片"
              @error="handleImageError('personalPhoto')"
            />
          </div>
        </el-form-item>
      </div>

      <div class="form-row">
        <el-form-item label="证件号码" prop="registerInfo.idNumber">
          <el-input
            :disabled="newMode == 'employer'"
            v-model="formData.registerInfo.idNumber"
            placeholder="证件号码"
          />
        </el-form-item>
        <el-form-item label="电话号码" prop="phonenumber">
          <el-input
            v-model="formData.phonenumber"
            placeholder="请输入电话号码"
            maxlength="11"
          >
            <template slot="prepend">+86</template>
          </el-input>
        </el-form-item>
      </div>

      <div class="form-row">
        <el-form-item label="性别" prop="registerInfo.gender">
          <el-select
            :disabled="newMode == 'employer'"
            v-model="formData.registerInfo.gender"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option label="男" value="男" />
            <el-option label="女" value="女" />
          </el-select>
        </el-form-item>
        <el-form-item label="民族" prop="registerInfo.ethnicity">
          <el-select
            :disabled="newMode == 'employer'"
            v-model="formData.registerInfo.ethnicity"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option label="汉族" value="汉族" />
            <el-option label="蒙古族" value="蒙古族" />
            <el-option label="回族" value="回族" />
            <el-option label="藏族" value="藏族" />
            <el-option label="维吾尔族" value="维吾尔族" />
            <el-option label="苗族" value="苗族" />
            <el-option label="彝族" value="彝族" />
            <el-option label="壮族" value="壮族" />
            <el-option label="布依族" value="布依族" />
            <el-option label="朝鲜族" value="朝鲜族" />
            <el-option label="满族" value="满族" />
            <el-option label="侗族" value="侗族" />
            <el-option label="瑶族" value="瑶族" />
            <el-option label="白族" value="白族" />
            <el-option label="土家族" value="土家族" />
            <el-option label="哈尼族" value="哈尼族" />
            <el-option label="哈萨克族" value="哈萨克族" />
            <el-option label="傣族" value="傣族" />
            <el-option label="黎族" value="黎族" />
            <el-option label="僳僳族" value="僳僳族" />
            <el-option label="佤族" value="佤族" />
            <el-option label="畲族" value="畲族" />
            <el-option label="高山族" value="高山族" />
            <el-option label="拉祜族" value="拉祜族" />
            <el-option label="水族" value="水族" />
            <el-option label="东乡族" value="东乡族" />
            <el-option label="纳西族" value="纳西族" />
            <el-option label="景颇族" value="景颇族" />
            <el-option label="柯尔克孜族" value="柯尔克孜族" />
            <el-option label="土族" value="土族" />
            <el-option label="达斡尔族" value="达斡尔族" />
            <el-option label="仫佬族" value="仫佬族" />
            <el-option label="羌族" value="羌族" />
            <el-option label="布朗族" value="布朗族" />
            <el-option label="撒拉族" value="撒拉族" />
            <el-option label="毛南族" value="毛南族" />
            <el-option label="仡佬族" value="仡佬族" />
            <el-option label="锡伯族" value="锡伯族" />
            <el-option label="阿昌族" value="阿昌族" />
            <el-option label="普米族" value="普米族" />
            <el-option label="塔吉克族" value="塔吉克族" />
            <el-option label="怒族" value="怒族" />
            <el-option label="乌孜别克族" value="乌孜别克族" />
            <el-option label="俄罗斯族" value="俄罗斯族" />
            <el-option label="鄂温克族" value="鄂温克族" />
            <el-option label="德昂族" value="德昂族" />
            <el-option label="保安族" value="保安族" />
            <el-option label="裕固族" value="裕固族" />
            <el-option label="京族" value="京族" />
            <el-option label="塔塔尔族" value="塔塔尔族" />
            <el-option label="独龙族" value="独龙族" />
            <el-option label="鄂伦春族" value="鄂伦春族" />
            <el-option label="赫哲族" value="赫哲族" />
            <el-option label="门巴族" value="门巴族" />
            <el-option label="珞巴族" value="珞巴族" />
            <el-option label="基诺族" value="基诺族" />
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="籍贯" prop="registerInfo.nativePlace">
          <el-select
            :disabled="newMode == 'employer'"
            v-model="formData.registerInfo.nativePlace"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option label="北京" value="北京" />
            <el-option label="天津" value="天津" />
            <el-option label="上海" value="上海" />
            <el-option label="重庆" value="重庆" />
            <el-option label="河北" value="河北" />
            <el-option label="山西" value="山西" />
            <el-option label="辽宁" value="辽宁" />
            <el-option label="吉林" value="吉林" />
            <el-option label="黑龙江" value="黑龙江" />
            <el-option label="江苏" value="江苏" />
            <el-option label="浙江" value="浙江" />
            <el-option label="安徽" value="安徽" />
            <el-option label="福建" value="福建" />
            <el-option label="江西" value="江西" />
            <el-option label="山东" value="山东" />
            <el-option label="河南" value="河南" />
            <el-option label="湖北" value="湖北" />
            <el-option label="湖南" value="湖南" />
            <el-option label="广东" value="广东" />
            <el-option label="海南" value="海南" />
            <el-option label="四川" value="四川" />
            <el-option label="贵州" value="贵州" />
            <el-option label="云南" value="云南" />
            <el-option label="陕西" value="陕西" />
            <el-option label="甘肃" value="甘肃" />
            <el-option label="青海" value="青海" />
            <el-option label="台湾" value="台湾" />
            <el-option label="内蒙古自治区" value="内蒙古自治区" />
            <el-option label="广西壮族自治区" value="广西壮族自治区" />
            <el-option label="西藏自治区" value="西藏自治区" />
            <el-option label="宁夏回族自治区" value="宁夏回族自治区" />
            <el-option label="新疆维吾尔自治区" value="新疆维吾尔自治区" />
            <el-option label="香港特别行政区" value="香港特别行政区" />
            <el-option label="澳门特别行政区" value="澳门特别行政区" />
          </el-select>
        </el-form-item> -->
      </div>

      <div class="form-row">
        <el-form-item label="出生日期" prop="registerInfo.birthDate">
          <el-date-picker
            :disabled="newMode == 'employer'"
            v-model="formData.registerInfo.birthDate"
            type="date"
            placeholder="选择出生日期"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="政治面貌" prop="registerInfo.politicalStatus">
          <el-select
            :disabled="newMode == 'employer'"
            v-model="formData.registerInfo.politicalStatus"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option label="中国共产党党员" value="中国共产党党员" />
            <el-option label="中国共产党预备党员" value="中国共产党预备党员" />
            <el-option
              label="中国共产主义青年团团员"
              value="中国共产主义青年团团员"
            />
            <el-option
              label="中国国民党革命委员会党员"
              value="中国国民党革命委员会党员"
            />
            <el-option label="中国民主同盟盟员" value="中国民主同盟盟员" />
            <el-option label="中国民主建国会会员" value="中国民主建国会会员" />
            <el-option label="中国民主促进会会员" value="中国民主促进会会员" />
            <el-option label="中国农工民主党党员" value="中国农工民主党党员" />
            <el-option label="中国致公党党员" value="中国致公党党员" />
            <el-option label="九三学社社员" value="九三学社社员" />
            <el-option
              label="台湾民主自治同盟盟员"
              value="台湾民主自治同盟盟员"
            />
            <el-option label="无党派民主人士" value="无党派民主人士" />
            <el-option label="群众" value="群众" />
            <el-option label="其他" value="其他" />
          </el-select>
        </el-form-item>
      </div>

      <!-- <div class="form-row">
        <el-form-item label="所在项目" prop="registerInfo.projectName">
          <el-input
            :disabled="newMode == 'employer'"
            v-model="formData.registerInfo.projectName"
            placeholder="所在项目"
            clearable
          />
        </el-form-item>
        <el-form-item label="所在区域" prop="registerInfo.region">
          <el-select
            :disabled="newMode == 'employer'"
            v-model="formData.registerInfo.region"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option label="东区" value="东区" />
            <el-option label="西区" value="西区" />
            <el-option label="仁和区" value="仁和区" />
            <el-option label="米易县" value="米易县" />
            <el-option label="盐边县" value="盐边县" />
          </el-select>
        </el-form-item>
      </div> -->
      <div class="form-row">
        <el-form-item label="最高学历" prop="registerInfo.highestEducation">
          <el-select
            :disabled="newMode == 'employer'"
            v-model="formData.registerInfo.highestEducation"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option label="小学" value="小学" />
            <el-option label="初中" value="初中" />
            <el-option label="高中" value="高中" />
            <el-option label="中专" value="中专" />
            <el-option label="大专" value="大专" />
            <el-option label="本科" value="本科" />
            <el-option label="硕士研究生" value="硕士研究生" />
            <el-option label="博士研究生" value="博士研究生" />
          </el-select>
        </el-form-item>
        <el-form-item label="所学专业" prop="registerInfo.major">
          <!-- <el-select
            :disabled="newMode == 'employer'"
            v-model="formData.registerInfo.major"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option label="社会工作" value="社会工作" />
            <el-option label="社会学" value="社会学" />
            <el-option label="应用心理学" value="应用心理学" />
            <el-option label="社区管理与服务" value="社区管理与服务" />
            <el-option label="公共事业管理" value="公共事业管理" />
            <el-option label="行政管理" value="行政管理" />
            <el-option label="劳动与社会保障" value="劳动与社会保障" />
            <el-option label="法学" value="法学" />
            <el-option label="心理学" value="心理学" />
            <el-option label="教育学" value="教育学" />
            <el-option label="社会保障" value="社会保障" />
            <el-option label="社会福利" value="社会福利" />
            <el-option label="社会政策" value="社会政策" />
            <el-option label="社会管理" value="社会管理" />
            <el-option label="人类学" value="人类学" />
          </el-select> -->
          <el-input
            v-model="formData.registerInfo.major"
            placeholder="请输入所学专业"
            clearable
          />
        </el-form-item>
      </div>

      <div class="form-row">
        <el-form-item label="邮箱" prop="registerInfo.email">
          <el-input
            v-model="formData.registerInfo.email"
            placeholder="邮箱"
            clearable
            disabled
            style="width: 39.8%"
          />
        </el-form-item>
      </div>
    </div>

    <div class="form-section">
      <h2 class="section-title">社会工作信息</h2>

      <div class="form-row">
        <el-form-item label="单位性质" prop="registerInfo.unitNature">
          <el-select
            v-model="formData.registerInfo.unitNature"
            placeholder="请选择"
            style="width: 100%"
            @change="handleUnitNatureChange"
            :disabled="mode === 'info'"
          >
            <el-option label="基层自治组织" value="基层自治组织" />
            <el-option label="行政事业单位" value="行政事业单位" />
            <el-option label="社会组织" value="社会组织" />
            <el-option label="社区备案组织" value="社区备案组织" />
            <el-option label="本协会会员" value="本协会会员" />
          </el-select>
        </el-form-item>

        <el-form-item label="单位名称" prop="registerInfo.unitName">
          <el-input
            v-model="formData.registerInfo.unitName"
            placeholder="单位名称"
            clearable
            :disabled="mode === 'info'"
          />
        </el-form-item>
      </div>

      <div class="form-row">
        <el-form-item label="职称" prop="registerInfo.professionalTitle">
          <el-input
            :disabled="newMode == 'employer'"
            v-model="formData.registerInfo.professionalTitle"
            placeholder="职称"
            clearable
          />
        </el-form-item>
        <el-form-item label="现任职务" prop="registerInfo.position">
          <el-cascader
            v-model="formData.registerInfo.position"
            :options="position"
            style="width: 100%"
            placeholder="请选择现任职务"
            v-if="formData.registerInfo.unitNature === '基层自治组织'"
          ></el-cascader>
          <el-input
            v-model="formData.registerInfo.position"
            placeholder="请输入现任职务"
            clearable
            v-else
          />
        </el-form-item>
      </div>

      <div class="form-row">
        <el-form-item
          label="证明资料"
          prop="supportingDocuments"
          v-if="
            formData.registerInfo.unitNature === '行政事业单位' ||
            formData.registerInfo.unitNature === '社会组织' ||
            formData.registerInfo.unitNature === '社区备案组织'
          "
        >
          <el-upload
            :action="uploadUrl"
            :on-error="handleUploadError"
            :before-upload="(file) => beforeUpload(uploadType, file)"
            :file-list="supportingDocumentsList"
            multiple
            :accept="accept"
            :on-success="
              (response, file, fileList) =>
                handleUploadSuccess(
                  'supportingDocuments',
                  response,
                  file,
                  fileList
                )
            "
            :on-remove="
              (file, fileList) =>
                handleRemove('supportingDocuments', file, fileList)
            "
            :on-preview="handlePreview"
          >
            <div v-if="formData.registerInfo.unitNature === '行政事业单位'">
              <el-button
                type="success"
                size="small"
                @click="submitUpload('pdf')"
              >
                修改行政事业单位证明
              </el-button>
              <div class="link-container">
                <div
                  style=""
                  v-for="url in formData.registerInfo.supportingDocuments"
                  :key="url"
                >
                  <el-link
                    @click.stop="onDownload(url)"
                    type="primary"
                    v-if="url.includes('.pdf')"
                  >
                    查看行政事业单位证明
                  </el-link>
                  <el-image
                    v-else
                    style="width: 120px; height: 100px"
                    :src="url"
                    @click.stop="openPreview(url)"
                  >
                  </el-image>
                </div>
              </div>
            </div>
            <div v-else-if="formData.registerInfo.unitNature === '社会组织'">
              <el-button
                slot="trigger"
                size="small"
                type="primary"
                @click="submitUpload('pdf')"
              >
                修改社会组织证明
              </el-button>
              <el-button
                style="margin-left: 10px"
                size="small"
                type="success"
                @click="submitUpload('image')"
              >
                修改社会组织证书
              </el-button>

              <div class="link-container">
                <div
                  style=""
                  v-for="url in formData.registerInfo.supportingDocuments"
                  :key="url"
                >
                  <el-link
                    @click.stop="onDownload(url)"
                    type="primary"
                    v-if="url.includes('.pdf')"
                  >
                    查看社会组织证明
                  </el-link>
                  <el-image
                    v-else
                    style="width: 120px; height: 100px"
                    :src="url"
                    @click.stop="openPreview(url)"
                  >
                  </el-image>
                </div>
              </div>
            </div>
            <div
              v-else-if="formData.registerInfo.unitNature === '社区备案组织'"
            >
              <el-button
                type="success"
                size="small"
                @click="submitUpload('pdf')"
              >
                修改备案组织
              </el-button>
              <div class="link-container">
                <div
                  style=""
                  v-for="url in formData.registerInfo.supportingDocuments"
                  :key="url"
                >
                  <el-link
                    @click.stop="onDownload(url)"
                    type="primary"
                    v-if="url.includes('.pdf')"
                  >
                    查看备案组织
                  </el-link>
                  <el-image
                    v-else
                    style="width: 120px; height: 100px"
                    :src="url"
                    @click.stop="openPreview(url)"
                  >
                  </el-image>
                </div>
              </div>
            </div>
            <el-button type="success" size="small" :disabled="true" v-else>
              无需上传证明资料
            </el-button>
          </el-upload>
        </el-form-item>
        <el-form-item
          label="证明资料"
          prop="memberCode"
          v-else-if="formData.registerInfo.unitNature === '本协会会员'"
        >
          <div>
            <el-input
              v-model="formData.registerInfo.memberCode"
              placeholder="请输入会员编码"
              clearable
              style="width: 76.5%"
              @blur="() => $refs.resumeForm.validateField('memberCode')"
            />
            <el-button
              style="margin-left: 10px"
              type="success"
              size="small"
              @click="submitApplication('/register/applyMembership')"
            >
              申请入会
            </el-button>
          </div>
        </el-form-item>
        <el-form-item label="证明资料" v-else>
          <el-button type="success" size="small" :disabled="true">
            无需上传证明资料
          </el-button>
        </el-form-item>

        <!-- 社会工作者证书等级 -->
        <el-form-item
          label="社会工作者证书等级"
          prop="socialWorkerCertificateLevel"
        >
          <el-select
            v-model="formData.socialWorkerCertificateLevel"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option label="助理" value="助理" />
            <el-option label="中级" value="中级" />
            <el-option label="高级" value="高级" />
          </el-select>
        </el-form-item>
      </div>

      <div class="form-row">
        <el-form-item label="等级证书" prop="certificateUpload">
          <el-upload
            :action="uploadUrl"
            :on-success="
              (response, file, fileList) =>
                handleUploadSuccess(
                  'certificateUpload',
                  response,
                  file,
                  fileList
                )
            "
            :on-error="handleUploadError"
            :before-upload="(file) => beforeUpload(uploadType, file)"
            :file-list="certificateUploadList"
            :on-remove="
              (file, fileList) =>
                handleRemove('certificateUpload', file, fileList)
            "
            :accept="accept"
            multiple
          >
            <el-button
              type="success"
              size="small"
              @click="submitUpload('image')"
            >
              上传等级证书
            </el-button>
          </el-upload>
          <div
            v-if="
              formData.registerInfo.certificateUpload &&
              formData.registerInfo.certificateUpload.length > 0
            "
            class="image-preview"
          >
            <img
              v-for="(img, index) in formData.registerInfo.certificateUpload"
              :key="index"
              :src="img"
              :alt="'等级证书' + (index + 1)"
              @error="handleImageError('certificateUpload', index)"
            />
          </div>
        </el-form-item>
      </div>
    </div>

    <div class="form-section">
      <h2 class="section-title">提交说明</h2>
      <el-form-item label="说明" prop="registerInfo.submitInstructions">
        <el-input
          :disabled="newMode == 'employer'"
          v-model="formData.registerInfo.submitInstructions"
          type="textarea"
          :rows="4"
          placeholder="请输入说明"
        />
      </el-form-item>
    </div>
    <!-- 自定义预览弹窗 -->
    <el-dialog
      :visible.sync="previewVisible"
      width="50%"
      :before-close="closePreview"
      top="5vh"
    >
      <img :src="previewUrl" style="width: 100%" />
    </el-dialog>
  </el-form>
</template>

<script>
import { modifyInfo } from "@/api/personal.js";
import { getInfo } from "@/api/api.js";
export default {
  name: "PersonalInfoForm",
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    /* uploadUrl: {
      type: String,
      default: "",
    }, */
    mode: {
      type: String,
      default: "info",
    },
  },
  data() {
    return {
      formData: {
        nickName: "",
        email: "",
        phonenumber: "",
        registerInfo: {
          personalPhoto: "",
          idType: "",
          idNumber: "",
          ethnicity: "",
          nativePlace: "",
          politicalStatus: "",
          gender: "",
          birthDate: "",
          maritalStatus: "",
          projectName: "",
          region: "",
          graduationDate: "",
          major: "",
          almaMater: "",
          highestEducation: "",
          highestEducationCertificate: [],
          unitNature: "",
          unitName: "",
          unitCategory: "",
          professionalTitle: "",
          position: "",
          supervisionType: "",
          workField: "",
          isCurrentlySocialWorker: "",
          socialWorkYears: "",
          socialWorkerCertificateLevel: "",
          certificateUpload: [],
          contactAddress: "",
          mobile: "",
          postalCode: "",
          socialWorkSpecialty: [],
          filingType: "",
          supportingDocuments: [],
          workExperiences: [
            {
              companyName: "",
              position: "",
              socialWorkType: "",
              startDate: "",
              endDate: "",
              description: "",
            },
          ],
          submitInstructions: "",
        },
      },
      graduationYears: Array.from(
        { length: 2026 - 1972 + 1 },
        (_, i) => 2026 - i
      ),
      personalPhotoList: [],
      highestEducationCertificateList: [],
      certificateUploadList: [],
      supportingDocumentsList: [],
      rules: {
        nickName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            min: 2,
            max: 10,
            message: "长度在 2 到 10 个字符",
            trigger: "blur",
          },
        ],
        "registerInfo.idType": [
          { required: true, message: "请选择证件类型", trigger: "change" },
        ],
        "registerInfo.idNumber": [
          { required: true, message: "请输入证件号码", trigger: "blur" },
          {
            pattern:
              /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/,
            message: "请输入正确的身份证号码",
            trigger: "blur",
          },
        ],
        "registerInfo.gender": [
          { required: true, message: "请选择性别", trigger: "change" },
        ],
        "registerInfo.ethnicity": [
          { required: true, message: "请选择民族", trigger: "change" },
        ],
        "registerInfo.politicalStatus": [
          { required: true, message: "请选择政治面貌", trigger: "change" },
        ],
        "registerInfo.birthDate": [
          { required: true, message: "请选择出生日期", trigger: "change" },
        ],
        "registerInfo.projectName": [
          { required: true, message: "请输入所在项目", trigger: "blur" },
        ],
        "registerInfo.region": [
          { required: true, message: "请选择所在区域", trigger: "change" },
        ],
        "registerInfo.major": [
          { required: true, message: "请输入所学专业", trigger: "blur" },
        ],
        "registerInfo.highestEducation": [
          { required: true, message: "请选择最高学历", trigger: "change" },
        ],
        "registerInfo.unitNature": [
          { required: true, message: "请选择单位性质", trigger: "change" },
        ],
        "registerInfo.unitName": [
          { required: true, message: "请输入单位名称", trigger: "blur" },
        ],
        "registerInfo.professionalTitle": [
          { required: true, message: "请输入职称", trigger: "blur" },
        ],
        "registerInfo.position": [
          { required: true, message: "请选择现任职务", trigger: "change" },
          { required: true, message: "请输入现任职务", trigger: "blur" },
        ],
        phonenumber: [
          { required: true, message: "请输入手机", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        "registerInfo.email": [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { type: "email", message: "请输入正确的邮箱地址", trigger: "blur" },
        ],
      },
      newMode: "info",
      position: [
        {
          value: "两委",
          label: "两委",
          children: [
            {
              value: "正职",
              label: "正职",
            },
            {
              value: "副职",
              label: "副职",
            },
            {
              value: "专职委员",
              label: "专职委员",
            },
          ],
        },
        {
          value: "专职社工岗",
          label: "专职社工岗",
        },
        {
          value: "综合事务岗",
          label: "综合事务岗",
        },
        {
          value: "基础事务岗",
          label: "基础事务岗",
        },
        {
          value: "持有社会工作职业资格水平证书人员",
          label: "持有社会工作职业资格水平证书人员",
        },
      ],
      //上传
      accept: "",
      uploadType: "",
      uploadUrl: "https://huachenglargescreen.planttech.cn/apis/common/upload",
      previewVisible: false,
      previewUrl: "",
    };
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.formData = { ...this.formData, ...newVal };
        }
      },
      deep: true,
      immediate: true,
    },
    mode: {
      handler(newVal) {
        if (newVal) {
          this.newMode = newVal;
        }
      },
      deep: true,
      immediate: true,
    },
    personalPhotoList: {
      handler(newVal) {
        if (newVal) {
          console.log(newVal);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // 下载文件
    onDownload(url) {
      window.open(url, "_blank");
    },
    submitUpload(type) {
      this.accept = type === "image" ? `image/*` : `.${type}`;
      this.uploadType = type;
    },
    handleUploadSuccess(propName, response, file, fileList) {
      console.log(this.formData.registerInfo[propName]);
      const imageUrl = response.data;
      if (propName && imageUrl) {
        if (propName === "personalPhoto") {
          this.formData.registerInfo[propName] = imageUrl;
        } else {
          this.formData.registerInfo[propName] = fileList.map((item) =>
            item.response ? item.response.data : item.url
          );
          console.log(this.formData.registerInfo[propName]);
        }

        const listName = propName + "List";
        if (this[listName]) {
          this[listName] = fileList;
        }
        this.$message.success("证明资料上传成功！");
      }
    },
    handleRemove(field, file, fileList) {
      if (field === "personalPhoto") {
        this.formData.registerInfo[field] = "";
        this.personalPhotoList = [];
      } else {
        this.formData.registerInfo[field] = fileList.map((item) =>
          item.response ? item.response.data.url : item.url
        );
        const listName = field + "List";
        if (this[listName]) {
          this[listName] = fileList;
        }
      }
      this.$emit("input", this.formData);
    },
    handlePreview(file) {
      // 如果文件已上传至服务器，file.url 为服务器返回的地址
      if (file.url) {
        window.open(file.url, "_blank");
      }
      // 如果是本地文件且尚未上传，可以使用 URL.createObjectURL 临时预览
      else if (file.raw) {
        const objectUrl = URL.createObjectURL(file.raw);
        window.open(objectUrl, "_blank");
        // 注意：为了释放内存，可以在预览后稍加延迟 revoke，但新标签页打开后需等页面关闭，此处不做立即释放
      } else {
        this.$message.warning("无法预览该文件");
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning("个人免冠照片只能上传一张");
    },
    handleImageError(field, index) {
      this.$message.warning("图片加载失败，已自动移除");

      if (field === "personalPhoto") {
        this.formData.registerInfo[field] = "";
        this.personalPhotoList = [];
      } else {
        this.formData.registerInfo[field].splice(index, 1);
        const listName = field + "List";
        if (this[listName] && this[listName].length > index) {
          this[listName].splice(index, 1);
        }
      }
      this.$emit("input", this.formData);
    },
    handleUploadError(error) {
      console.error("上传失败详情:", error);
      this.$message.error("上传失败");
    },
    beforeUpload(type = "image", file) {
      console.log(type, file);
      if (type === "pdf") {
        const isPDF = file.type === "application/pdf";
        if (!isPDF) {
          this.$message.error("只能上传 PDF 格式的文件！");
          return false;
        }
        // 可选：限制文件大小，例如 10MB
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
          this.$message.error("文件大小不能超过 10MB！");
          return false;
        }
        return true; // 允许上传
      } else {
        const isImage = file.type.startsWith("image/");
        if (!isImage) {
          this.$message.error("只能上传图片文件！");
          return false;
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 2MB！");
          return false;
        }
        return isImage && isLt2M;
      }
    },
    addWorkExperience() {
      this.formData.registerInfo.workExperiences.push({
        companyName: "",
        position: "",
        socialWorkType: "",
        startDate: "",
        endDate: "",
        description: "",
      });
      this.$emit("input", this.formData);
    },
    removeWorkExperience(index) {
      if (this.formData.registerInfo.workExperiences.length > 1) {
        this.formData.registerInfo.workExperiences.splice(index, 1);
        this.$emit("input", this.formData);
      } else {
        this.$message.warning("至少保留一条工作经历");
      }
    },
    submitForm() {
      this.$refs.personalForm.validate((valid) => {
        if (this.formData.registerInfo.unitNature === "本协会会员") {
          this.formData.registerInfo.supportingDocuments = [];
        } else {
          this.formData.registerInfo.memberCode = "";
        }
        const needSupportingDocs = [
          "行政事业单位",
          "社会组织",
          "社区备案组织",
        ].includes(this.formData.registerInfo.unitNature);
        const isMember = this.formData.registerInfo.unitNature === "本协会会员";
        if (
          needSupportingDocs &&
          this.formData.registerInfo.unitNature === "社会组织"
        ) {
          if (
            this.formData.registerInfo.supportingDocuments[0].includes(".pdf")
          ) {
            this.$message.error("请上传社会组织证书");
            return false;
          } else {
            this.$message.error("请上传社会组织证明");
            return false;
          }
        } else {
          if (
            needSupportingDocs &&
            (!this.formData.registerInfo.supportingDocuments ||
              this.formData.registerInfo.supportingDocuments.length === 0)
          ) {
            this.$message.error("请上传证明资料");
            return false;
          }
        }

        if (
          isMember &&
          (!this.formData.registerInfo.memberCode ||
            this.formData.registerInfo.memberCode.trim() === "")
        ) {
          this.$message.error("请输入会员编码");
          return false;
        }
        if (valid) {
          modifyInfo({
            origin: "h5",
            ...this.formData,
            registerInfoTemp: this.formData.registerInfo,
          })
            .then((res) => {
              if (res.data.code === 200) {
                this.$message.success("保存成功");
                getInfo().then((userRes) => {
                  if (userRes.data.code === 200) {
                    localStorage.setItem(
                      "userInfo",
                      JSON.stringify(userRes.data.data)
                    );
                  }
                });
              } else {
                this.$message.error(res.data.msg || "保存失败");
              }
            })
            .catch((err) => {
              this.$message.error("保存失败");
            });
        } else {
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.personalForm.resetFields();
    },
    openPreview(url) {
      this.previewUrl = url;
      this.previewVisible = true;
    },
    closePreview() {
      this.previewVisible = false;
    },
    handleUnitNatureChange() {
      console.log(this.formData.registerInfo.unitNature);
      this.formData.registerInfo.supportingDocuments = [];
    },
  },
};
</script>

<style lang="less" scoped>
.link-container {
  text-align: left;
  display: flex;
  gap: 10px;
  margin-top: 10px;
}
::v-deep .el-form-item__content {
  line-height: 20px !important;
}
.form-section {
  margin-bottom: 40px;
  padding: 25px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  background: #fafafa;

  .section-title {
    color: #2c3e50;
    margin-bottom: 25px;
    padding-bottom: 15px;
    font-size: 18px;
    font-weight: bold;
    border-bottom: 2px solid #409eff;
  }

  .form-row {
    display: flex;
    flex-wrap: wrap;
    gap: 25px;
    margin-bottom: 20px;

    .el-form-item {
      flex: 1;
      min-width: 280px;
      margin-bottom: 20px;
    }
  }
}

.resume-form-content {
  max-width: 100%;

  .el-form-item__label {
    white-space: nowrap;
  }
}

.operation-button {
  border: none !important;
  background: transparent;
  font-size: 20px;
  padding: 0;
}

.operation-button-delete {
  color: #f56c6c;
}

.image-preview {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.image-preview img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.image-preview img:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}
</style>
